var $dc4c2ec600d80557$exports = {};
$dc4c2ec600d80557$exports = {
    "info": `Informa\xe7\xe3o`,
    "negative": `Erro`,
    "positive": `Sucesso`
};


export {$dc4c2ec600d80557$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
